module.exports = __webpack_public_path__ + "img/10016.1306ae29.jpg";